import { Injectable } from '@angular/core';
import { ApiConstants } from '@app/api-constants';
import { BaseService } from '@app/core/base.service';
import { UploadAttachmentService } from '@app/widget/services/upload-attachment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomService {

  constructor(public baseService:BaseService, public upload : UploadAttachmentService) { }

  public getAppUsersExcel(...args): any {
    const serviceOpts = ApiConstants.getAppUsersReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getResultExcel(...args): any {
    const serviceOpts = ApiConstants.getResultReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getChangeLogExcel(...args): any {
    const serviceOpts = ApiConstants.getChangeLogReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getCompanyExcel(...args): any {
    const serviceOpts = ApiConstants.getCompanyReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getSiteExcel(...args): any {
    const serviceOpts = ApiConstants.getSiteReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getUserInfoExcel(...args): any {
    const serviceOpts = ApiConstants.getUserInfoReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getWhitelistExcel(...args): any {
    const serviceOpts = ApiConstants.getWhitelistReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getControlgroupExcel(...args): any {
    const serviceOpts = ApiConstants.getControlgroupReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getControlgroupcountryExcel(...args): any {
    const serviceOpts = ApiConstants.getControlgroupcountryReportExcel;
    const params= args[0];
    if(args[1]){
      serviceOpts.showloading = false;
      serviceOpts.liteMessage = true;
    }
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }
  public getResponse(): any{
    const serviceOpts = ApiConstants.getImportStatus;
    const params= [];
    
    const subject = new Observable(observer => {
      this.baseService[serviceOpts.method.toLowerCase()](serviceOpts, params).subscribe((response) => {
        observer.next(response);
      },
        (err) => {
          observer.error(err);
        });
    });

    return subject;
  }


}
